import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getPriceLists = (
    token: string,
    backend: string,
    id?: string,
) => {
    return fetch(
        `${getApiUrl(backend)}price_lists${id ? '/' + id : ''}`,
        {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
};

export default getPriceLists